import React, { FunctionComponent } from 'react';

import { Modal } from 'components';
import { Text } from 'components/chroma';
import { productDisclosureStatementUrl } from 'scenes/common/helpers/contacts';

const SpecifiedContentsModal: FunctionComponent<{
  isOpen: boolean;
  onClose: () => void;
}> = ({ isOpen, onClose }) => (
  <Modal
    header="You can specify items at the home at no extra cost."
    isOpen={isOpen}
    onClose={onClose}
  >
    <Text>
      Specifying items for cover inside the home only does not cost you anything
      extra as long as you&#39;ve already included them in your total contents
      sum insured. Items you would like to cover under the optional extra,
      Portable contents cover will add to your premium but are covered anywhere
      in Australia including at the home. Portable contents excess applies.
    </Text>
    <Text>
      For full details, see{' '}
      <strong>Specified contents - inside your home</strong> in the{' '}
      <a
        href={productDisclosureStatementUrl()}
        target="_blank"
        rel="noopener noreferrer"
      >
        Product Disclosure Statement
      </a>
      .
    </Text>
  </Modal>
);

export default SpecifiedContentsModal;
